import { render, staticRenderFns } from "./TextTab.vue?vue&type=template&id=6e15277c&scoped=true&"
import script from "./TextTab.vue?vue&type=script&lang=js&"
export * from "./TextTab.vue?vue&type=script&lang=js&"
import style0 from "./TextTab.vue?vue&type=style&index=0&id=6e15277c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15277c",
  null
  
)

export default component.exports